import React from "react";
import {
  PieChart, Pie, Cell, Tooltip,
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
} from "recharts";
import dayjs from "dayjs";

const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50", "#00bfff"];

const Charts = ({ expenses }) => {
  const categoryData = expenses.reduce((acc, curr) => {
    const existing = acc.find((item) => item.name === curr.category);
    if (existing) existing.value += curr.amount;
    else acc.push({ name: curr.category, value: curr.amount });
    return acc;
  }, []);

  const monthlyDataMap = {};
  expenses.forEach((e) => {
    const month = dayjs(e.date).format("MMM YYYY");
    monthlyDataMap[month] = (monthlyDataMap[month] || 0) + e.amount;
  });

  const barData = Object.entries(monthlyDataMap).map(([name, value]) => ({
    name,
    value,
  }));

  return (
    <div className="charts">
      <h3>📊 Category Breakdown</h3>
      <PieChart width={300} height={300}>
        <Pie data={categoryData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={100}>
          {categoryData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
        </Pie>
        <Tooltip />
      </PieChart>

      <h3>📅 Monthly Spending</h3>
      <BarChart width={500} height={300} data={barData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="value" fill="#8884d8" />
      </BarChart>
    </div>
  );
};

export default Charts;
